import { render, staticRenderFns } from "./questionItemZh.vue?vue&type=template&id=6071e876&scoped=true"
import script from "./questionItemZh.vue?vue&type=script&lang=js"
export * from "./questionItemZh.vue?vue&type=script&lang=js"
import style0 from "./questionItemZh.vue?vue&type=style&index=0&id=6071e876&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6071e876",
  null
  
)

export default component.exports